import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/103781c2-bc14-4b28-988b-6ca01a70a8b4.png" 
              alt="KVADRUM Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-2xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              KVADRUM
            </span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              VPN Features
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Pricing & Download
            </button>
            <button
              onClick={() => scrollToSection('support')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Support
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2.5 bg-teal-600 text-white text-sm font-medium rounded-full hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
